module.exports = __webpack_public_path__ + "02_very_short_grey.d8fae40b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_very_short_grey.png
// module id = SpIn
// module chunks = 0